import React from 'react';

import ListGroup from '../../Components/ListGroup';
import Heading from '../../Components/Heading';
import ImageBlurFallback from '../../Components/ImageBlurFallback';

import ML_PNG from '../../Assets/v2/ThreeHundred/ML.png';
import REACT_PNG from '../../Assets/v2/ThreeHundred/React.png';
import FULL_STACK_PNG from '../../Assets/v2/ThreeHundred/FullStack.png';

import ML_WEBP from '../../Assets/v2/ThreeHundred/ML.webp';
import REACT_WEBP from '../../Assets/v2/ThreeHundred/React.webp';
import FULL_STACK_WEBP from '../../Assets/v2/ThreeHundred/FullStack.webp';

import ML_FALLBACK from '../../Assets/fallbacks/ThreeHundred/ML.jpg';
import REACT_FALLBACK from '../../Assets/fallbacks/ThreeHundred/React.jpg';
import FULL_STACK_FALLBACK from '../../Assets/fallbacks/ThreeHundred/FullStack.jpg';

const CourseCard = ({ title, image, webpImage, fallbackImage, className }) => {
  return (
    <div className={`th-course-card ${className}`}>
      <div className="th-course-image-box">
        <ImageBlurFallback
          className="th-course-image"
          fallbackImage={fallbackImage}
          src={image}
          webpImage={webpImage}
        />
      </div>

      <div className="th-course-title-box">
        <span className="th-course-title">{title}</span>
      </div>
    </div>
  );
};

const Courses = () => {
  return (
    <ListGroup
      containerClassName="th-courses-container"
      title={
        <Heading
          className="th-courses-title"
          title="YOU DECIDE YOUR FIELD TO EXCEL"
        />
      }
      description="Choose any one of the following courses"
      descriptionClassName="th-courses-description"
      count={3}>
      <CourseCard
        image={ML_PNG}
        webpImage={ML_WEBP}
        fallbackImage={ML_FALLBACK}
        title="MACHINE LEARNING AND DEEP LEARNING"
      />

      <CourseCard
        image={REACT_PNG}
        webpImage={REACT_WEBP}
        fallbackImage={REACT_FALLBACK}
        title="FRONT END WEB & APP DEVELOPMENT USING REACT"
      />

      <CourseCard
        image={FULL_STACK_PNG}
        webpImage={FULL_STACK_WEBP}
        fallbackImage={FULL_STACK_FALLBACK}
        title="FULL STACK WEB DEV USING RUBY ON RAILS & REACT JS"
      />

       <CourseCard
        image={FULL_STACK_PNG}
        webpImage={FULL_STACK_WEBP}
        fallbackImage={FULL_STACK_FALLBACK}
        title="Sales"
      />

<CourseCard
         image={ML_PNG}
         webpImage={ML_WEBP}
         fallbackImage={ML_FALLBACK}
        title="Marketing"
      />


    </ListGroup>
  );
};

export default Courses;



// WEBPACK FOOTER //
// ./src/Pages/ThreeHundred/Courses.js